import React from 'react';

import { ReactLogo } from './ReactLogo';


 function Footer() {
  return (
    
    <div>
<center>
    <footer>
      
      <div>
      Copyright ©   {new Date().getFullYear()} Servicios adicionales de icontec:  https://www.icontec.org 
      </div>
    </footer>
  
    </center>
<ReactLogo />
    </div>
    
  );
}
export default Footer;